import * as C from '../constants';
import * as api from '../api';
import { createAction } from 'redux-actions';
import * as ActionCreators from './ActionCreators';

export const receivedFetchUserShopItemAll = createAction(
  C.ACTION_TYPES.USER_SHOP_ITEM_RECEIVED_ALL,
  (shop_items: ShopItem[]) => ({
    shop_items,
  })
);

export const fetchUserShopItemAll = (page?: number, keyword?: string) => async (
  dispatch: any,
  getState: any
) => {
  dispatch(
    ActionCreators.updateBuyShopItemState(C.BUY_SHOP_ITEM_STATE.FETCHING)
  );
  try {
    const { searchKey } = getState().favourite;
    const payload = {
      page,
      keyword: searchKey,
    };
    const json = await api.favourite.fetchFavouriteShopItem(payload);
    const { items: shop_items, total } = json;
    dispatch(ActionCreators.actionUpdateFavouriteShopItemTotal(total));
    // TODO: remove these action
    dispatch(
      ActionCreators.actionAddItemToFavourite({
        shop_items,
      })
    );
    dispatch(receivedFetchUserShopItemAll(shop_items));

    dispatch(ActionCreators.actionAddFavouriteShopItem(shop_items));
    dispatch(
      ActionCreators.updateBuyShopItemState(C.BUY_SHOP_ITEM_STATE.DEFAULT)
    );
  } catch (e) {
    dispatch(
      ActionCreators.updateBuyShopItemState(C.BUY_SHOP_ITEM_STATE.SERVER_ERROR)
    );
  }
};



// WEBPACK FOOTER //
// ./app/actions/UserShopItemActionCreators.ts